// extracted by mini-css-extract-plugin
module.exports = {"name":"CustomerTag_name__heenO","new":"CustomerTag_new__B2vSB","fraud":"CustomerTag_fraud__dxAfF","vip":"CustomerTag_vip__0LPst"};